var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5039 0C9.62762 0 0 9.62763 0 21.5039C0 33.3802 9.62763 43.0078 21.5039 43.0078C33.3802 43.0078 43.0078 33.3802 43.0078 21.5039C43.0078 9.62762 33.3802 0 21.5039 0ZM14.8813 30.6976C14.8404 32.2294 13.6083 33.4616 12.0765 33.5025H9.2716V21.426C9.2716 19.8769 10.5274 18.6211 12.0765 18.6211H14.9592L14.8813 30.6976ZM24.3088 26.1007C24.3088 27.6929 23.0181 28.9835 21.426 28.9835H18.699V16.8291C18.699 15.28 19.9548 14.0243 21.5039 14.0243H24.3867L24.3088 26.1007ZM33.6583 21.5039C33.6583 23.096 32.3676 24.3867 30.7755 24.3867H28.0486V12.2323C28.0486 10.6832 29.3043 9.42743 30.8534 9.42743H33.7362L33.6583 21.5039Z",
    fill: "#E21979"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarLogo);
export default __webpack_public_path__ + "static/media/sidebar-logo.a8275b3c26bdd59f242c162b63bd3a90.svg";
export { ForwardRef as ReactComponent };